/* Rose Atelier — global JS */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = window.themeMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.querySelector('[data-nav-wrap]');
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  /* ---------- sliders ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slide]');
    if (!btn) return;
    const slider = document.getElementById(btn.getAttribute('data-target'));
    if (!slider) return;
    const card = slider.querySelector(':scope > *');
    const step = card ? card.getBoundingClientRect().width + 20 : 300;
    slider.scrollBy({ left: btn.dataset.slide === 'next' ? step : -step, behavior: 'smooth' });
  });

  /* ---------- variant picker (shared: product page + quick shop) ---------- */
  function initProductForm(wrap) {
    const jsonEl = wrap.querySelector('[data-product-json]');
    if (!jsonEl || wrap.dataset.pfInit) return;
    wrap.dataset.pfInit = '1';
    const product = JSON.parse(jsonEl.textContent);
    const groups = [...wrap.querySelectorAll('.option-group')];
    if (!groups.length) return;
    const idInput = wrap.querySelector('input[name="id"]');
    const priceEl = wrap.querySelector('[data-price]');
    const buyBtn = wrap.querySelector('[data-buy-btn]');

    const selectedValues = () => groups.map((g) => {
      const c = g.querySelector('input:checked');
      return c ? c.value : null;
    });
    const findVariant = (vals) => product.variants.find((v) => v.options.every((o, i) => o === vals[i]));

    function update() {
      const vals = selectedValues();

      groups.forEach((g, i) => {
        const label = g.querySelector('[data-selected-value]');
        if (label && vals[i]) label.textContent = vals[i];
        g.querySelectorAll('input[type="radio"]').forEach((inp) => {
          const test = vals.slice(); test[i] = inp.value;
          const v = findVariant(test);
          const lab = wrap.querySelector(`label[for="${inp.id}"]`);
          if (lab) lab.classList.toggle('is-oos', !(v && v.available));
        });
      });

      const variant = findVariant(vals);
      if (!variant) { if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.compare_at_price > variant.price
        ? `<s>${money(variant.compare_at_price)}</s> ${money(variant.price)}`
        : money(variant.price);
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.dataset.labelAdd : 'Out of stock';
      }
      if (wrap.dataset.updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, scope: wrap } }));
    }

    wrap.addEventListener('change', (e) => { if (e.target.matches('.option-group input')) update(); });
    update();
  }
  window.initProductForm = initProductForm;
  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* ---------- quick shop modal ---------- */
  const qsModal = document.querySelector('[data-qs-modal]');
  const qsBody = qsModal ? qsModal.querySelector('[data-qs-body]') : null;

  function closeQs() { document.body.classList.remove('qs-open'); if (qsModal) qsModal.setAttribute('aria-hidden', 'true'); }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-quick-shop-open]');
    if (openBtn && qsBody) {
      const tpl = openBtn.closest('.product-card').querySelector('template[data-qs-template]');
      if (!tpl) return;
      qsBody.innerHTML = '';
      qsBody.appendChild(tpl.content.cloneNode(true));
      qsBody.querySelectorAll('[data-product-form]').forEach(initProductForm);
      document.body.classList.add('qs-open');
      qsModal.setAttribute('aria-hidden', 'false');
      const close = qsModal.querySelector('[data-qs-close]');
      if (close) close.focus();
    }
    if (e.target.closest('[data-qs-close]')) closeQs();
  });

  /* ---------- cart drawer ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  let lastRecsId = null;

  function openDrawer() { document.body.classList.add('drawer-open'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeQs(); } });

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-checkout-btn]').forEach((el) => {
      el.disabled = cart.item_count === 0;
    });
    if (!drawer) return;

    const itemsEl = drawer.querySelector('[data-cart-items]');
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    subtotalEl.textContent = money(cart.items_subtotal_price);

    const bar = drawer.querySelector('[data-shipbar]');
    if (bar) {
      const threshold = parseFloat(bar.dataset.threshold || '0') * 100;
      const fill = bar.querySelector('.shipbar__fill');
      const label = bar.querySelector('[data-shipbar-label]');
      if (threshold > 0) {
        const remaining = Math.max(threshold - cart.items_subtotal_price, 0);
        fill.style.width = Math.min((cart.items_subtotal_price / threshold) * 100, 100) + '%';
        label.textContent = remaining > 0
          ? 'Add ' + money(remaining) + ' more to unlock free standard shipping.'
          : 'Your order qualifies for free standard shipping.';
      } else { bar.hidden = true; }
    }

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn--ghost" href="/collections/all">Shop all</a></div>';
      const recs = drawer.querySelector('[data-drawer-recs]');
      if (recs) recs.hidden = true;
      if (window.updateGwp) window.updateGwp(cart);
      return;
    }

    itemsEl.innerHTML = cart.items.map((item, i) => `
      <div class="cart-line" data-line="${i + 1}">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : ''}" alt="" width="76" height="95" loading="lazy">
        <div>
          <p class="cart-line__title"><a href="${item.url}">${item.product_title}</a></p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : ''}
          <div class="qty">
            <button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>
            <input type="text" value="${item.quantity}" readonly aria-label="Quantity">
            <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
          </div>
          <br><button type="button" class="cart-line__remove" data-remove>Remove</button>
        </div>
        <div>${money(item.final_line_price)}</div>
      </div>`).join('');

    loadRecommendations(cart.items[0].product_id);
    if (window.updateGwp) window.updateGwp(cart);
  }

  async function loadRecommendations(productId) {
    const recs = drawer ? drawer.querySelector('[data-drawer-recs]') : null;
    if (!recs || productId === lastRecsId) { if (recs && recs.querySelector('.drawer-rec')) recs.hidden = false; return; }
    lastRecsId = productId;
    try {
      const res = await fetch(`/recommendations/products.js?product_id=${productId}&limit=4`);
      const data = await res.json();
      const row = recs.querySelector('[data-drawer-recs-row]');
      if (!data.products || !data.products.length) { recs.hidden = true; return; }
      row.innerHTML = data.products.map((p) => `
        <div class="drawer-rec">
          <a href="${p.url}"><img src="${p.featured_image}" alt="" loading="lazy" width="120" height="150"></a>
          <p class="drawer-rec__title"><a href="${p.url}">${p.title}</a></p>
          <p class="drawer-rec__price">${money(p.price)}</p>
          ${p.variants.length === 1 && p.available
            ? `<form data-ajax-cart><input type="hidden" name="id" value="${p.variants[0].id}"><button type="submit" class="btn btn--ghost drawer-rec__btn">Add</button></form>`
            : `<a class="btn btn--ghost drawer-rec__btn" href="${p.url}">View</a>`}
        </div>`).join('');
      recs.hidden = false;
    } catch (err) { recs.hidden = true; }
  }

  document.addEventListener('click', async (e) => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    let qty = null;
    if (e.target.closest('[data-qty]')) {
      const input = line.querySelector('input');
      qty = Math.max(parseInt(input.value, 10) + parseInt(e.target.closest('[data-qty]').dataset.qty, 10), 0);
    }
    if (e.target.closest('[data-remove]')) qty = 0;
    if (qty === null) return;
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: qty })
    });
    renderCart(await res.json());
  });

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart], form.js-ajax-cart');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error((await res.json()).description || 'Error');
      await refreshCart();
      if (form.closest('[data-qs-modal]')) closeQs();
      if (window.themeCartDrawerEnabled) openDrawer();
      btn.textContent = 'Added ✓';
    } catch (err) {
      btn.textContent = (err.message || 'Sold out').slice(0, 40);
    } finally {
      btn.disabled = false;
      setTimeout(() => { btn.textContent = original; }, 2000);
    }
  });

  /* qty stepper */
  document.addEventListener('click', (e) => {
    const stepBtn = e.target.closest('.qty [data-step]');
    if (!stepBtn) return;
    const input = stepBtn.parentElement.querySelector('input');
    input.value = Math.max(parseInt(input.value, 10) + parseInt(stepBtn.dataset.step, 10), 1);
  });

  refreshCart();
})();

/* ===================== v1.2 modules ===================== */
(function () {
  'use strict';
  const money = (c) => (window.themeMoneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2));

  /* ---------- hero carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach((el) => {
    const slides = [...el.querySelectorAll('.hero-slide')];
    const dots = [...el.querySelectorAll('[data-carousel-dot]')];
    if (slides.length < 2) return;
    let i = 0, timer = null;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const start = () => {
      if (reduced || el.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(() => go(i + 1), parseInt(el.dataset.interval, 10) || 6000);
    };
    const stop = () => { if (timer) clearInterval(timer); };

    el.querySelector('[data-carousel-next]')?.addEventListener('click', () => { go(i + 1); start(); });
    el.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { go(i - 1); start(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); start(); }));
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- predictive search ---------- */
  const sd = document.querySelector('[data-search-drawer]');
  if (sd) {
    const input = sd.querySelector('[data-search-input]');
    const results = sd.querySelector('[data-search-results]');
    const popular = sd.querySelector('[data-search-popular]');
    let t = null, ctrl = null;

    const openSearch = () => {
      document.body.classList.add('search-open');
      sd.setAttribute('aria-hidden', 'false');
      setTimeout(() => input.focus(), 60);
    };
    const closeSearch = () => {
      document.body.classList.remove('search-open');
      sd.setAttribute('aria-hidden', 'true');
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest('[data-search-close]')) closeSearch();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });

    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        if (popular) popular.hidden = false;
        return;
      }
      t = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const r = data.resources.results;
          if (popular) popular.hidden = true;

          const products = (r.product || []).map((p) => `
            <a class="ps-item" href="${p.url}">
              <img src="${p.image ? p.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : ''}" alt="" loading="lazy" width="56" height="70">
              <span>
                <span class="ps-item__title">${p.title}</span>
                <span class="ps-item__price">${p.price ? money(parseFloat(p.price) * 100) : ''}</span>
              </span>
            </a>`).join('');

          const others = [...(r.collection || []), ...(r.article || [])]
            .map((c) => `<a class="ps-link" href="${c.url}">${c.title}</a>`).join('');

          results.innerHTML = (products || others)
            ? `${products ? `<h4>Products</h4><div class="ps-grid">${products}</div>` : ''}
               ${others ? `<h4>Pages</h4><div class="ps-links">${others}</div>` : ''}
               <a class="btn btn--line ps-all" href="/search?q=${encodeURIComponent(q)}">View all results</a>`
            : `<p class="ps-empty">No results for “${q}”. Try another term.</p>`;
        } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
      }, 250);
    });
  }

  /* ---------- selling plans ---------- */
  document.querySelectorAll('[data-selling-plans]').forEach((wrap) => {
    const select = wrap.querySelector('[data-plan-select]');
    const input = wrap.querySelector('[data-plan-input]');
    wrap.addEventListener('change', (e) => {
      if (!e.target.matches('[data-plan-mode]')) return;
      const sub = e.target.value === 'subscription';
      select.hidden = !sub;
      input.disabled = !sub;
    });
    if (input) input.disabled = true;
  });

  /* ---------- virtual try-on ---------- */
  const tm = document.querySelector('[data-tryon-modal]');
  if (tm) {
    const frame = tm.querySelector('[data-tryon-frame]');
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tryon-open]');
      if (btn) {
        frame.innerHTML = `<iframe src="${btn.dataset.tryonUrl}" allow="camera; microphone" title="Virtual try-on" loading="lazy"></iframe>`;
        document.body.classList.add('tryon-open');
        tm.setAttribute('aria-hidden', 'false');
      }
      if (e.target.closest('[data-tryon-close]')) {
        frame.innerHTML = '';
        document.body.classList.remove('tryon-open');
        tm.setAttribute('aria-hidden', 'true');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('tryon-open')) {
        frame.innerHTML = '';
        document.body.classList.remove('tryon-open');
        tm.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ---------- gift with purchase ---------- */
  const gwp = document.querySelector('[data-gwp]');
  if (gwp) {
    const threshold = parseFloat(gwp.dataset.threshold || '0') * 100;
    const status = gwp.querySelector('[data-gwp-status]');
    const btns = [...gwp.querySelectorAll('[data-gwp-btn]')];

    window.updateGwp = (cart) => {
      if (!threshold) { gwp.hidden = true; return; }
      const hasGift = cart.items.some((it) => it.properties && it.properties._gift);
      const eligibleTotal = cart.items
        .filter((it) => !(it.properties && it.properties._gift))
        .reduce((s, it) => s + it.final_line_price, 0);
      const unlocked = eligibleTotal >= threshold;

      gwp.hidden = cart.item_count === 0;
      btns.forEach((b) => { b.disabled = !unlocked || hasGift; });

      if (hasGift) status.textContent = 'Your free gift has been added. Enjoy!';
      else if (unlocked) status.textContent = 'Select 1 free gift below.';
      else status.textContent = `You're ${money(threshold - eligibleTotal)} away from choosing your free gift.`;
    };
  }
})();

/* ---------- shade finder quiz ---------- */
document.querySelectorAll('[data-quiz]').forEach((quiz) => {
  const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
  if (!steps.length) return;
  const progress = quiz.querySelector('[data-quiz-progress]');
  const resultEl = quiz.querySelector('[data-quiz-result]');
  const grid = quiz.querySelector('[data-quiz-result-grid]');
  const backBtn = quiz.querySelector('[data-quiz-back]');
  const section = quiz.closest('section');
  const collectionHandle = (window.themeQuizCollection || 'all');
  const limit = parseInt(window.themeQuizLimit || '4', 10);
  let step = 0;
  const answers = [];

  const money = (c) => (window.themeMoneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2));

  const show = (n) => {
    step = n;
    steps.forEach((s, k) => s.classList.toggle('is-active', k === n));
    progress.style.width = ((n / steps.length) * 100) + '%';
    backBtn.hidden = n === 0;
    resultEl.hidden = true;
  };

  async function finish() {
    steps.forEach((s) => s.classList.remove('is-active'));
    progress.style.width = '100%';
    backBtn.hidden = true;
    resultEl.hidden = false;
    grid.innerHTML = '<p>Finding your matches…</p>';

    const query = answers.map((a) => `tag:${a}`).join(' AND ');
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}`);
      const data = await res.json();
      let products = data.resources.results.product || [];
      if (!products.length) {
        // fallback: match any answer instead of all
        const loose = await fetch(`/search/suggest.json?q=${encodeURIComponent(answers.join(' OR '))}&resources[type]=product&resources[limit]=${limit}`);
        products = ((await loose.json()).resources.results.product) || [];
      }
      grid.innerHTML = products.length
        ? products.map((p) => `
          <div class="product-card">
            <a href="${p.url}" class="product-card__media"><img src="${p.image ? p.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2') : ''}" alt="" loading="lazy"></a>
            <h3 class="product-card__title"><a href="${p.url}">${p.title}</a></h3>
            <p class="product-card__price">${p.price ? money(parseFloat(p.price) * 100) : ''}</p>
          </div>`).join('')
        : `<p>No exact match found. <a class="btn btn--line" href="/collections/${collectionHandle}">Browse all products</a></p>`;
    } catch (err) {
      grid.innerHTML = `<p>Something went wrong. <a class="btn btn--line" href="/collections/${collectionHandle}">Browse all products</a></p>`;
    }
  }

  quiz.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-quiz-answer]');
    if (opt) {
      answers[step] = opt.dataset.quizAnswer;
      if (step + 1 < steps.length) show(step + 1); else finish();
      return;
    }
    if (e.target.closest('[data-quiz-back]')) { answers.pop(); show(Math.max(step - 1, 0)); }
    if (e.target.closest('[data-quiz-restart]')) { answers.length = 0; show(0); }
  });

  show(0);
});

/* ---------- store locator filter ---------- */
document.querySelectorAll('[data-locator]').forEach((loc) => {
  const input = loc.querySelector('[data-locator-search]');
  const stores = [...loc.querySelectorAll('[data-store]')];
  const empty = loc.querySelector('[data-locator-empty]');
  input.addEventListener('input', () => {
    const q = input.value.trim().toLowerCase();
    let visible = 0;
    stores.forEach((s) => {
      const match = !q || s.dataset.search.includes(q);
      s.hidden = !match;
      if (match) visible++;
    });
    empty.hidden = visible > 0;
  });
});

/* ---------- product gallery ---------- */
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-gallery-thumb]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-gallery]');
  const idx = thumb.dataset.galleryThumb;
  gallery.querySelectorAll('[data-gallery-slide]').forEach((s) => {
    s.classList.toggle('is-active', s.dataset.gallerySlide === idx);
  });
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => {
    const on = t === thumb;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-selected', on ? 'true' : 'false');
  });
});

/* variant change -> jump gallery to that variant's image */
document.addEventListener('variant:change', (e) => {
  const { variant, scope } = e.detail;
  if (!variant || !variant.featured_media) return;
  const gallery = (scope.closest('.product') || document).querySelector('[data-gallery]');
  if (!gallery) return;
  const pos = variant.featured_media.position - 1;
  const thumb = gallery.querySelector(`[data-gallery-thumb="${pos}"]`);
  if (thumb) thumb.click();
  else {
    gallery.querySelectorAll('[data-gallery-slide]').forEach((s) => {
      s.classList.toggle('is-active', s.dataset.gallerySlide === String(pos));
    });
  }
});

/* ---------- share ---------- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-share-btn]');
  if (!btn) return;
  const url = btn.dataset.shareUrl;
  const label = btn.textContent;
  if (navigator.share) {
    try { await navigator.share({ url }); } catch (err) { /* cancelled */ }
  } else {
    try {
      await navigator.clipboard.writeText(url);
      btn.textContent = 'Link copied ✓';
      setTimeout(() => { btn.textContent = label; }, 2000);
    } catch (err) { /* noop */ }
  }
});

/* ---------- related products (Shopify recommendations section) ---------- */
document.querySelectorAll('[data-related]').forEach(async (el) => {
  try {
    const res = await fetch(el.dataset.url);
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const fresh = html.querySelector('[data-related]');
    if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    else el.remove();
  } catch (err) { el.remove(); }
});

/* ---------- account: recover password panel ---------- */
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-recover-open]')) {
    e.preventDefault();
    const p = document.querySelector('[data-recover]');
    if (p) { p.hidden = false; p.scrollIntoView({ behavior: 'smooth' }); }
  }
  if (e.target.closest('[data-recover-close]')) {
    const p = document.querySelector('[data-recover]');
    if (p) p.hidden = true;
  }
});

/* ---------- account: address forms ---------- */
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-addr-toggle]');
  if (toggle) {
    const form = document.querySelector(`[data-addr-form="${toggle.dataset.addrToggle}"]`);
    if (form) form.hidden = !form.hidden;
  }

  const del = e.target.closest('[data-addr-delete]');
  if (del) {
    if (!confirm(del.dataset.confirm || 'Delete this address?')) return;
    const f = document.createElement('form');
    f.method = 'post';
    f.action = del.dataset.url;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f);
    f.submit();
  }
});

/* ---------- account: country / province linkage ---------- */
document.querySelectorAll('[data-country]').forEach((countryEl) => {
  const wrap = countryEl.closest('.field-row');
  const provinceEl = wrap ? wrap.querySelector('[data-province]') : null;
  const provinceWrap = wrap ? wrap.querySelector('[data-province-wrap]') : null;
  if (!provinceEl) return;

  const sync = () => {
    const opt = countryEl.options[countryEl.selectedIndex];
    let provinces = [];
    try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (err) { provinces = []; }
    provinceEl.innerHTML = '';
    if (!provinces.length) {
      if (provinceWrap) provinceWrap.hidden = true;
      return;
    }
    if (provinceWrap) provinceWrap.hidden = false;
    const want = provinceEl.dataset.default;
    provinces.forEach(([value, label]) => {
      const o = document.createElement('option');
      o.value = value;
      o.textContent = label;
      if (value === want) o.selected = true;
      provinceEl.appendChild(o);
    });
  };

  if (countryEl.dataset.default) countryEl.value = countryEl.dataset.default;
  countryEl.addEventListener('change', sync);
  sync();
});

/* ---------- footer: mobile collapsible columns ---------- */
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-footer-toggle]');
  if (!t || window.innerWidth >= 760) return;
  t.closest('.footer-col').classList.toggle('is-open');
});

/* ---------- back to top ---------- */
(function () {
  const btn = document.querySelector('[data-back-to-top]');
  if (!btn) return;
  btn.hidden = false;
  const onScroll = () => {
    btn.classList.toggle('is-visible', window.scrollY > 600);
  };
  btn.addEventListener('click', () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ---------- PDP: mobile sticky buy bar ---------- */
(function () {
  const bar = document.querySelector('[data-sticky-buy]');
  if (!bar) return;
  const mainBtn = document.querySelector('.product__buy [data-buy-btn]');
  const form = document.querySelector('.product__buy form.js-ajax-cart, .product__buy form[data-ajax-cart]');
  const priceEl = bar.querySelector('[data-sticky-price]');
  const addBtn = bar.querySelector('[data-sticky-add]');
  if (!mainBtn || !form) return;

  /* show once the main CTA scrolls out of view */
  const io = new IntersectionObserver(
    ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
    { rootMargin: '-80px 0px 0px 0px' }
  );
  io.observe(mainBtn);

  /* clicking sticky = submitting the real form (keeps one source of truth) */
  addBtn.addEventListener('click', () => {
    form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* keep sticky price + availability in sync with the variant picker */
  document.addEventListener('variant:change', (e) => {
    const v = e.detail.variant;
    if (!v) return;
    const fmt = window.themeMoneyFormat || '${{amount}}';
    priceEl.textContent = fmt.replace(/\{\{\s*amount\s*\}\}/, (v.price / 100).toFixed(2));
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Out of stock';
  });
})();

/* ---------- announcement rotator ---------- */
(function () {
  const track = document.querySelector('[data-announce-track]');
  if (!track) return;
  const items = [...track.querySelectorAll('.announcement__item')];
  if (items.length < 2) return;
  const section = track.closest('.announcement');
  let i = 0;
  setInterval(() => {
    items[i].classList.remove('is-active');
    i = (i + 1) % items.length;
    items[i].classList.add('is-active');
  }, 5000);
})();

/* ===================== v5 modules ===================== */

/* ---------- gallery: carousel + thumbs + zoom ---------- */
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  if (slides.length < 2) return;
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  let i = 0;

  const go = (n) => {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
    thumbs.forEach((t, k) => {
      const on = k === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
  };
  gallery._goto = go;

  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(i - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(i + 1));

  /* swipe on touch */
  let x0 = null;
  const main = gallery.querySelector('[data-gallery-main]');
  main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  main.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
    x0 = null;
  }, { passive: true });
});

/* variant change -> jump gallery to that variant's media */
document.addEventListener('variant:change', (e) => {
  const { variant, scope } = e.detail;
  if (!variant || !variant.featured_media) return;
  const gallery = (scope.closest('.product') || document).querySelector('[data-gallery]');
  if (!gallery || !gallery._goto) return;
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
  if (idx > -1) gallery._goto(idx);
});

/* ---------- image zoom lightbox ---------- */
(function () {
  let modal = null;
  const open = (src) => {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'zoom-modal';
      modal.innerHTML = '<button class="zoom-modal__close" aria-label="Close">×</button><img alt="">';
      document.body.appendChild(modal);
      modal.addEventListener('click', close);
    }
    modal.querySelector('img').src = src;
    document.body.classList.add('zoom-open');
  };
  const close = () => document.body.classList.remove('zoom-open');

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-zoom-open]');
    if (t) { e.preventDefault(); open(t.dataset.zoomSrc); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* ---------- short description: See more / See less ---------- */
document.querySelectorAll('[data-short-desc]').forEach((el) => {
  const body = el.querySelector('[data-short-desc-body]');
  const btn = el.querySelector('[data-short-desc-toggle]');
  /* hide the toggle when the text already fits */
  if (body.scrollHeight <= body.clientHeight + 2) { btn.hidden = true; return; }
  btn.addEventListener('click', () => {
    const open = el.classList.toggle('is-open');
    btn.textContent = open ? 'See less' : 'See more';
  });
});

/* ---------- SKU / inventory / back-in-stock follow the variant ---------- */
document.addEventListener('variant:change', (e) => {
  const { variant } = e.detail;
  if (!variant) return;

  const sku = document.querySelector('[data-sku]');
  if (sku) sku.textContent = variant.sku ? `SKU: ${variant.sku}` : '';

  const inv = document.querySelector('[data-inventory]');
  if (inv) {
    const threshold = parseInt(inv.dataset.threshold, 10) || 10;
    const qty = variant.inventory_quantity;
    const tracked = variant.inventory_management != null;
    let cls = 'ok', text = inv.dataset.inStockText || 'In stock, ready to ship';
    if (!variant.available) { cls = 'out'; text = 'Out of stock'; }
    else if (tracked && qty > 0 && qty <= threshold) { cls = 'low'; text = `Only ${qty} left`; }
    inv.innerHTML = `<span class="inventory__dot inventory__dot--${cls}"></span>${text}`;
  }

  const bis = document.querySelector('[data-bis]');
  if (bis) {
    bis.hidden = variant.available;
    if (variant.available) {
      bis.querySelector('[data-bis-panel]').hidden = true;
    }
  }
});

/* remember the in-stock label so the JS above can restore it */
(function () {
  const inv = document.querySelector('[data-inventory]');
  if (inv && !inv.dataset.inStockText) {
    const t = inv.textContent.trim();
    if (t && !/^Only|^Out of stock/.test(t)) inv.dataset.inStockText = t;
  }
})();

/* ---------- back-in-stock panel ---------- */
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-bis-toggle]')) return;
  const panel = document.querySelector('[data-bis-panel]');
  if (panel) panel.hidden = !panel.hidden;
});

/* ---------- complementary products (Shopify recommendations, intent=complementary) ---------- */
document.querySelectorAll('[data-complementary]').forEach(async (el) => {
  try {
    const res = await fetch(el.dataset.url);
    const html = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = html.querySelector('[data-complementary]');
    if (fresh && fresh.querySelector('.comp-card')) {
      el.innerHTML = fresh.innerHTML;
      el.hidden = false;
    } else {
      el.remove(); /* nothing configured in Search & Discovery yet */
    }
  } catch (err) {
    el.remove();
  }
});

/* ---------- before & after comparison slider ---------- */
document.querySelectorAll('[data-compare]').forEach((el) => {
  const range = el.querySelector('[data-compare-range]');
  const after = el.querySelector('[data-compare-after]');
  const handle = el.querySelector('[data-compare-handle]');
  const sync = () => {
    const v = range.value;
    after.style.clipPath = `inset(0 0 0 ${v}%)`;
    handle.style.left = `${v}%`;
  };
  range.addEventListener('input', sync);
  sync();
});

/* ---------- shoppable image hotspots ---------- */
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-hotspot-toggle]');
  const insideCard = e.target.closest('[data-hotspot-card]');

  if (toggle) {
    const card = toggle.parentElement.querySelector('[data-hotspot-card]');
    const wasOpen = !card.hidden;
    /* only one open at a time */
    document.querySelectorAll('[data-hotspot-card]').forEach((c) => { c.hidden = true; });
    card.hidden = wasOpen;
    return;
  }
  if (!insideCard) {
    document.querySelectorAll('[data-hotspot-card]').forEach((c) => { c.hidden = true; });
  }
});

/* ---------- collection: faceted filtering ---------- */
(function () {
  const results = document.querySelector('[data-collection-results]');
  if (!results) return;

  const panel = document.querySelector('[data-filters]');
  const scrim = document.querySelector('[data-filter-scrim]');
  const form = document.querySelector('[data-filter-form]');
  const sortEl = document.querySelector('[data-sort-by]');

  /* --- drawer open/close (mobile) --- */
  const setPanel = (open) => {
    if (!panel) return;
    document.body.classList.toggle('filters-open', open);
    if (scrim) scrim.hidden = !open;
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-filter-open]')) setPanel(true);
    if (e.target.closest('[data-filter-close]') || e.target.closest('[data-filter-scrim]')) setPanel(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setPanel(false);
  });

  /* --- swap results in without a page jump --- */
  let pending = null;

  const render = (html, url) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const swap = (sel) => {
      const next = doc.querySelector(sel);
      const cur = document.querySelector(sel);
      if (next && cur) cur.innerHTML = next.innerHTML;
    };
    swap('[data-collection-results]');
    swap('[data-filters]');
    swap('.collection-toolbar');
    /* active pills may appear or disappear entirely */
    const nextPills = doc.querySelector('.active-filters');
    const curPills = document.querySelector('.active-filters');
    if (nextPills && curPills) curPills.replaceWith(nextPills);
    else if (nextPills && !curPills) document.querySelector('.collection-toolbar').after(nextPills);
    else if (!nextPills && curPills) curPills.remove();

    window.history.pushState({ filtered: true }, '', url);
    results.classList.remove('is-loading');
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const go = (url) => {
    results.classList.add('is-loading');
    if (pending) pending.abort();
    pending = new AbortController();
    fetch(url, { signal: pending.signal })
      .then((r) => r.text())
      .then((html) => render(html, url))
      .catch((err) => {
        if (err.name === 'AbortError') return;
        window.location.href = url; /* fall back to a real navigation */
      });
  };

  const buildUrl = () => {
    const base = window.location.pathname;
    const params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
    }
    if (sortEl && sortEl.value) params.set('sort_by', sortEl.value);
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
  };

  /* filter inputs */
  if (form) {
    form.addEventListener('change', () => go(buildUrl()));
    form.addEventListener('submit', (e) => { e.preventDefault(); go(buildUrl()); });
    /* debounce the price inputs so we don't fire on every keystroke */
    let t;
    form.addEventListener('input', (e) => {
      if (e.target.type !== 'number') return;
      clearTimeout(t);
      t = setTimeout(() => go(buildUrl()), 500);
    });
  }

  /* sort */
  if (sortEl) sortEl.addEventListener('change', () => go(buildUrl()));

  /* pills, pagination, clear-all: intercept the link, keep the URL */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-filter-link]');
    if (!link) return;
    e.preventDefault();
    setPanel(false);
    go(link.href);
  });

  /* back / forward */
  window.addEventListener('popstate', () => {
    fetch(window.location.href)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-collection-results]');
        if (next) results.innerHTML = next.innerHTML;
      });
  });
})();

/* ---------- cart: order note (Cart API) ---------- */
(function () {
  const note = document.querySelector('[data-note-input]');
  if (!note) return;
  const msg = document.querySelector('[data-note-msg]');
  let t;
  note.addEventListener('input', () => {
    clearTimeout(t);
    t = setTimeout(async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
        if (msg) {
          msg.hidden = false;
          msg.textContent = 'Saved';
          setTimeout(() => { msg.hidden = true; }, 1800);
        }
      } catch (err) {
        console.error('Could not save the cart note', err);
      }
    }, 700);
  });
})();

/* ---------- cart: discount code ---------- */
(function () {
  const btn = document.querySelector('[data-discount-apply]');
  if (!btn) return;
  const input = document.querySelector('[data-discount-input]');
  const msg = document.querySelector('[data-discount-msg]');

  const apply = () => {
    const code = (input.value || '').trim();
    if (!code) {
      if (msg) { msg.hidden = false; msg.textContent = 'Enter a code first.'; }
      return;
    }
    /* Shopify validates the code and redirects on to checkout. An invalid code
       simply lands on checkout without a discount - it never errors out here. */
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
  };

  btn.addEventListener('click', apply);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); apply(); }
  });
})();

/* ---------- recently viewed ---------- */
(function () {
  const KEY = 'ra:recently-viewed';
  const MAX = 12;

  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  };
  const write = (list) => {
    try { sessionStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
    catch { /* private mode: silently skip, the feature is a nicety */ }
  };

  /* record the current product */
  const handle = document.body.dataset.productHandle;
  if (handle) {
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list);
  }

  /* render the section, if it's on this page */
  const section = document.querySelector('[data-recently-viewed]');
  if (!section) return;
  const row = section.querySelector('[data-rv-row]');

  const paint = async () => {
    const list = read().filter((h) => h !== handle);
    if (!list.length) { section.hidden = true; return; }

    const cards = await Promise.all(
      list.slice(0, 8).map(async (h) => {
        try {
          const res = await fetch(`/products/${h}?view=card`);
          if (!res.ok) return null;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.product-card')?.outerHTML || null;
        } catch { return null; }
      })
    );

    const good = cards.filter(Boolean);
    if (!good.length) { section.hidden = true; return; }
    row.innerHTML = good.join('');
    section.hidden = false;
  };

  section.querySelector('[data-rv-clear]')?.addEventListener('click', () => {
    write([]);
    section.hidden = true;
  });

  paint();
})();

/* ---------- accessibility: focus trap for drawers and modals ---------- */
(function () {
  const SELECTOR = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* Which container is currently modal, based on the body classes the drawers set. */
  const activeContainer = () => {
    const map = [
      ['cart-open', '[data-cart-drawer]'],
      ['nav-open', '[data-nav-drawer]'],
      ['search-open', '[data-search-drawer]'],
      ['filters-open', '[data-filters]'],
      ['zoom-open', '.zoom-modal'],
      ['qs-open', '[data-qs-modal]'],
      ['tryon-open', '[data-tryon-modal]']
    ];
    for (const [cls, sel] of map) {
      if (document.body.classList.contains(cls)) {
        const el = document.querySelector(sel);
        if (el) return el;
      }
    }
    return null;
  };

  let lastFocused = null;

  const observer = new MutationObserver(() => {
    const container = activeContainer();
    if (container && !container.dataset.trapped) {
      lastFocused = document.activeElement;
      container.dataset.trapped = 'true';
      const first = container.querySelector(SELECTOR);
      if (first) first.focus();
    } else if (!container) {
      document.querySelectorAll('[data-trapped]').forEach((el) => delete el.dataset.trapped);
      if (lastFocused && document.contains(lastFocused)) {
        lastFocused.focus();
        lastFocused = null;
      }
    }
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const container = activeContainer();
    if (!container) return;

    const items = [...container.querySelectorAll(SELECTOR)].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
